import template from './zone.html';

/* @ngInject */
function ZoneController(
  $scope,
  $q,
  $log,
  CameraService,
  ModalService,
  growl,
  ZoneSelectionRectService,
  ZoneSelectionPolyService,
  ZoneSelectionStore
) {
  const vm = this;

  const convertTo100 = 50;
  const simplifiedEq = 0.02;
  const maxRPGDamage = 9999;
  const rightAngle = 90;
  const halfCircle = 180;
  const threeQuarters = 270;
  const cropSize = 100;
  const zonesTitles = ['zoneOne', 'zoneTwo', 'zoneThree'];
  const irrelevantProfiles = [];

  let backupProfileState;
  let growlMessage;


  // let zoneProfilesRaw = null;

  // //////////////// //
  // PUBLIC VARIABLES //
  // //////////////// //
  vm.detectionSize = ZoneSelectionStore.state.detectionSize;
  vm.newVmd = true;
  vm.zoneProfiles = null;
  vm.activeProfile = null;

  vm.disableEdit = true;

  vm.prevInd = null;
  // vm.filterTemplates = null;
  vm.isOpen = {
    zoneDD: false
  };
  vm.showOverlays = true;
  vm.maxCamName = 15;
  vm.showOverlays = true;

  // //////////////// //
  // PUBLIC FUNCTIONS //
  // //////////////// //
  vm.$onInit = init;
  vm.$postLink = postLink;
  vm.changeActiveZone = changeActiveZone;
  vm.toggleDetectionZone = toggleDetectionZone;
  vm.addZoneProfile = addZoneProfile;
  vm.editName = editName;
  vm.saveName = saveName;
  vm.moveDetectionBoxIfOutOfBounds = moveDetectionBoxIfOutOfBounds;
  vm.testAlarm = testAlarm;
  vm.reset = reset;
  vm.deleteProfile = deleteProfile;
  vm.saveZone = saveZone;
  vm.toggleOverlayAction = toggleOverlayAction;
  vm.updateLightZoneOverlay = updateLightZoneOverlay;
  vm.polyOptions = () => true;

  function init() {
    _.assign(vm, vm.resolve);

    vm.showDetectionBox = false;

    // First call to check for vmd4 data
    CameraService.getAllVmd4Info(vm.camId)
      .then(({ data }) => {
        // splice out profiles not relevant to current stream
        data.profiles = _.filter(data.profiles, (pro) => {
          // intentionally only using == to allow for string<->number coercion
          // eslint-disable-next-line eqeqeq
          if (pro.camera == vm.streamId) {
            return true;
          }
          irrelevantProfiles.push(pro);
          return false;
        });
        // convert points from -1/1 to 0/100
        _.forEach(data.profiles, (pro) => {
          pro.triggers[0].data = _.map(pro.triggers[0].data, ([xx, yy]) => [
            (xx + 1) * convertTo100,
            (-yy + 1) * convertTo100
          ]);
        });
        backupProfileState = data;
        vm.zoneProfiles = angular.copy(data);

        changeActiveZone(0);

      })
      .catch((vmd4Err) => {
        const httpCodes = {
          redirect: 399,
          internalError: 500
        };
        if (vmd4Err.httpStatus > httpCodes.redirect && vmd4Err.httpStatus < httpCodes.internalError) {
          // vmd4 is not an option for this camera, follow old vmd1 procedure and let the zone-selection component
          // know that it needs to draw rectangles instead of polygons (newVmd = false)
          // TODO: Remove this code when no more vmd1 cameras exist
          return $q.all([
            getZones(vm.camId),
            getRotation(vm.camId)
          ])
            .then(([zones, rotation]) => {
              vm.newVmd = false;
              vm.rotation = rotation;
              vm.camZones = [];
              _.forEach(zones, (zone, i) => {
                zone.title = zonesTitles[i];

                /* rotate rect */
                const rect = {
                  degrees: parseInt(rotation, 10),
                  radians: parseInt(rotation, 10) * Math.PI / halfCircle
                };

                zone.top = -zone.top;
                zone.bottom = -zone.bottom;

                zone.cords = {};

                const cos = Math.cos(rect.radians);
                const sin = Math.sin(rect.radians);
                zone.cords.x = (((zone.left * cos) + (zone.top * sin)) * cropSize) / maxRPGDamage;
                zone.cords.y = (((-zone.left * sin) + (zone.top * cos)) * cropSize) / maxRPGDamage;
                zone.cords.x2 = (((zone.right * cos) + (zone.bottom * sin)) * cropSize) / maxRPGDamage;
                zone.cords.y2 = (((-zone.right * sin) + (zone.bottom * cos)) * cropSize) / maxRPGDamage;
                // Translate to positive coordinates
                if (rect.degrees === rightAngle || rect.degrees === halfCircle) {
                  zone.cords.x += cropSize;
                  zone.cords.x2 += cropSize;
                }
                if (rect.degrees === halfCircle || rect.degrees === threeQuarters) {
                  zone.cords.y -= cropSize;
                  zone.cords.y2 -= cropSize;
                }

                zone.cords.y = -zone.cords.y;
                zone.cords.y2 = -zone.cords.y2;

                if (zone.cords.x > zone.cords.x2) {
                  const tempx = zone.cords.x;
                  zone.cords.x = zone.cords.x2;
                  zone.cords.x2 = tempx;
                }
                if (zone.cords.y > zone.cords.y2) {
                  const tempy = zone.cords.y;
                  zone.cords.y = zone.cords.y2;
                  zone.cords.y2 = tempy;
                }

                /* rotate rect */
                if (_.isUndefined(zone.enabled)) {
                  zone.enabled = false;
                }
                vm.camZones.push(zone);
              });
              backupProfileState = angular.copy(vm.camZones);
              changeActiveZone(0);
            })
            .catch(vmd1Err => $q.reject(vmd1Err.error));
        }

        return $q.reject(vmd4Err.error);
      })
      .finally(() => {
        vm.loadingSpinners = true;
      });
  }

  function postLink() {
    const saveBtnWatcher = $scope.$watch(() => document.getElementById('save-btn'), (newV) => {
      if (newV) {
        saveBtnWatcher();

        const saveBtn = $('#zone-settings-container #save-btn');
        const enableContainer = $('#zone-settings-container #enable-container');
        saveBtn
          .on('mouseenter', () => {
            if (!vm.activeProfile.enabled) {
              enableContainer.addClass('annoying-disable-notification');
            }
          })
          .on('mouseleave', () => {
            enableContainer.removeClass('annoying-disable-notification');
          });
      }
    });
  }

  /**
   * If the ind would change the current zone, deactivates editing and calls the appropriate 'changeActive' method
   *
   * @param {number} ind from 0 to amount of zones - 1
   * @returns {boolean|undefined} void if the ind is not the previous ind or false
   */
  function changeActiveZone(ind) {
    if (ind !== vm.prevInd) {
      vm.disableEdit = true;
      return vm.newVmd ? changeActivePolyZone(ind) : changeActiveRectZone(ind);
    }
    return false;
  }

  /**
   * First updates the triggers and sizePercentage of the current activeProfile, then changes the activeProfile to
   * the new ind, deactivates detectionBox if necessary, assigns the new activeProfile's triggers to the polygon service
   * and sizePercentage
   *
   * @param {number} ind from 0 to amount of zones - 1
   *
   * @returns {undefined}
   */
  function changeActivePolyZone(ind) {
    // update the in-place model so that toggling between profile tabs will retain state
    // TODO: This if block could probably also be skipped if the ind === prevInd -- needs testing first
    if (vm.activeProfile) {
      vm.activeProfile.triggers[0].data = ZoneSelectionPolyService.getPathCoordinates();
      _.find(vm.activeProfile.filters, { type: 'sizePercentage' }).data =
          ZoneSelectionRectService.getDetectionBoxPercentage();
    }

    vm.prevInd = ind;
    vm.activeProfile = vm.zoneProfiles.profiles[ind];
    vm.filters = vm.activeProfile.filters;
    vm.newProfileName = vm.activeProfile.name;

    if (_.isArray(vm.activeProfile.filters)) {
      vm.activeProfile.filters = Object.fromEntries(vm.activeProfile.filters.map(fil => [fil.type, fil]));
    }

    if (vm.showDetectionBox) {
      vm.showDetectionBox = false;
      vm.toggleDetectionZone();
    }

    ZoneSelectionPolyService.assignPathActiveZone(vm.activeProfile.triggers[0].data);
    ZoneSelectionRectService.assignDetectionSizeOrToggle(false, vm.activeProfile.filters.sizePercentage.data);
  }

  /**
   * Updates the activeProfile with the current rect coordinates, changes the activeProfile to the new ind, and assigns
   * the new profile's cords through the rectangle service
   *
   * @param {number} ind from 0 to amount of zones - 1
   *
   * @returns {undefined}
   */
  function changeActiveRectZone(ind) {
    vm.prevInd = ind;
    if (vm.activeProfile) {
      vm.activeProfile.cords = ZoneSelectionRectService.getRectCoordinates();
    }

    vm.activeProfile = vm.camZones[ind];
    vm.newProfileName = vm.activeProfile.name;

    ZoneSelectionRectService.assignRectActiveZone(vm.activeProfile.cords);
    // call appropriate zoneselection methods with the currect path to data
  }

  /**
   * Shows/hides the detection box in the Zone Selection svg
   *
   * @returns {undefined}
   */
  function toggleDetectionZone() {
    ZoneSelectionRectService.assignDetectionSizeOrToggle(true);
  }

  /**
   * Makes a request to add a new vmd4 profile to the camera, retrieves the profile and converts its coordinates
   * to a 0-100 scale, pushes the new profile into the zoneProfiles and backupProfileState, then changes the active
   * profile
   *
   * @returns {undefined}
   */
  function addZoneProfile() {
    CameraService.addVmd4Profile(vm.camId)
      .then(({ data }) => {
        data.payload.presets = [];
        data.payload.triggers[0].data = _.map(data.payload.triggers[0].data, ([xx, yy]) => [
          (xx + 1) * convertTo100,
          (-yy + 1) * convertTo100
        ]);
        vm.zoneProfiles.profiles.push(data.payload);
        backupProfileState.profiles.push(angular.copy(data.payload));

        changeActivePolyZone(vm.zoneProfiles.profiles.length - 1);
      })
      .catch((err) => {
        growl.error(err, {
          title: 'Could not add a profile:'
        });
      });
  }

  function editName() {
    vm.disableEdit = false;
  }

  /**
   * If the inputted name is within the maxCamName limits, assigns it to the activeProfile's name and disables edit
   *
   * @returns {undefined}
   */
  function saveName() {
    if (_.get(vm, ['newProfileName', 'length']) < vm.maxCamName + 1) {
      vm.disableEdit = true;
      vm.activeProfile.name = vm.newProfileName;
    } else {
      growl.warning(`Please choose a name between 1 and ${vm.maxCamName} characters`, { title: 'Invalid Name' });
    }

  }

  /**
   * Determines if detection box has grown such that it extends outside bounds of svg and moves it back into bounds
   *
   * @param {string} axis 'X' or 'Y', denoting width or height, respectively
   *
   * @returns {undefined}
   */
  function moveDetectionBoxIfOutOfBounds(axis) {
    const dimension = axis === 'X' ? 'boxWidth' : 'boxHeight';
    const distanceToMove = vm.detectionSize[`upperLeft${axis}`] + vm.detectionSize[dimension];
    if (distanceToMove > 100) {
      vm.detectionSize[`upperLeft${axis}`] -= distanceToMove - 100;
    }
  }

  /**
   * Requests to trigger the camera's alarm and flashes a red alarm on the svg as visual indication of success
   *
   * @returns {undefined}
   */
  function testAlarm() {
    CameraService
      .testAlarm(vm.camId, vm.activeProfile.uid)
      .then(ZoneSelectionPolyService.triggerAlarm);
  }

  /**
   * Uses vmd type to determine which reset method to call
   *
   * @returns {undefined}
   */
  function reset() {
    return vm.newVmd ? resetPoly() : resetRect();
  }

  /**
   * Copies current profile's backup to reset then changes the active poly zone to notify and update the Zone Selection
   *
   * @returns {undefined}
   */
  function resetPoly() {
    vm.zoneProfiles.profiles[vm.prevInd] = angular.copy(backupProfileState.profiles[vm.prevInd]);
    changeActivePolyZone(vm.prevInd);
  }

  /**
   * Copies current profile's backup to reset then changes the active rect zone to notify and update the Zone Selection
   *
   * @returns {undefined}
   */
  function resetRect() {
    vm.camZones[vm.prevInd] = angular.copy(backupProfileState[vm.prevInd]);
    changeActiveRectZone(vm.prevInd);
  }

  /**
   * On confirmation, calls the appropriate profile delete method
   *
   * @param {number} ind from 0 to amount of zones - 1
   *
   * @returns {undefined}
   */
  function deleteProfile(ind) {
    return ModalService.confirmationModal({
      modalTitle: `Delete ${vm.zoneProfiles.profiles[ind].name}?`,
      onConfirm: () => {
        if (vm.newVmd) {
          deletePolyProfile(ind);
        } else {
          deleteRectZone(ind);
        }
      }
    });
  }

  /**
   * Splices the target profile and changes the active profile to the first one or sets to null and destroys the Zone
   * Selection store. Saves the current vmd4 profiles
   *
   * @param {number} ind from 0 to amount of zones - 1
   *
   * @returns {undefined}
   */
  function deletePolyProfile(ind) {
    vm.zoneProfiles.profiles.splice(ind, 1);
    backupProfileState.profiles.splice(ind, 1);

    if (vm.zoneProfiles.profiles.length) {
      changeActivePolyZone(0);
    } else {
      vm.activeProfile = null;
      ZoneSelectionPolyService.destroy();
    }
    saveVmd4Profile();
  }

  /**
   * Splices the target profile, changes the active rect profile to the first, and saves the state
   *
   * @param {number} ind from 0 to amount of zones - 1
   *
   * @returns {undefined}
   */
  function deleteRectZone(ind) {
    vm.camZones.splice(ind, 1);
    backupProfileState.splice(ind, 1);

    changeActiveRectZone(0);
    saveVmd1Zone();
  }

  /**
   * Validates the existence of a profile name then calls the appropriate save method
   *
   * @returns {undefined}
   */
  function saveZone() {
    growlMessage = growl.info('Attempting to save profiles...', { disableCloseButton: true });
    // tell user what's happening
    if (!vm.newProfileName) {
      growlMessage.destroy();
      return growl.error('Please choose a valid name', {
        title: 'Name Too Short or Empty'
      });
    }

    return vm.newVmd ? saveVmd4Profile() : saveVmd1Zone();
  }

  // TODO: Break up some of the inner logic into separate methods
  /**
   * If profiles exist, validates against intersection of polygon points, then validates detection box min/max size.
   * Assigns the altered polygon points (triggers) to the changedProfile, iterates over all profiles to convert their
   * values from 0-100 to the camera's -1 to 1 scale, maps the appropriate filters, sends request to save vmd4 profiles,
   * updates the profile within the backup state upon success
   *
   * @returns {undefined}
   */
  function saveVmd4Profile() {
    let allProfiles;
    let triggers;
    // retain copy of index so that changing active profile doesn't change it while request is pending
    const profileToSaveIndex = vm.prevInd;
    // retain reference to backup profile object in case array indexes change while request is pending
    const backupProfile = backupProfileState?.profiles?.[profileToSaveIndex];
    let updatedProfile;
    if (vm.zoneProfiles.profiles.length) {
      if (ZoneSelectionPolyService.testForIntersections()) {
        growlMessage.destroy();
        return growl.error('Please correct crossing lines', {
          title: 'Intersection Detected:'
        });
      }

      triggers = ZoneSelectionPolyService.getPathCoordinates();
      const detectionPercents = ZoneSelectionRectService.getDetectionBoxPercentage();

      const MIN_DETECTION_AMT = 3;
      if (detectionPercents[0] < MIN_DETECTION_AMT || detectionPercents[1] < MIN_DETECTION_AMT) {
        growlMessage.destroy();
        return growl.error('It must have a width and height of at least 3 percent', {
          title: 'Detection size too small:'
        });
      }
      if (angular.isUndefined(detectionPercents[0]) || angular.isUndefined(detectionPercents[1])) {
        growlMessage.destroy();
        return growl.error('It must have a width and height less than 100', {
          title: 'Invalid detection size:'
        });
      }

      allProfiles = angular.copy(vm.zoneProfiles);
      updatedProfile = allProfiles.profiles[profileToSaveIndex];

      updatedProfile.triggers[0].data = triggers;
      for (let i = 0; i < allProfiles.profiles.length; i += 1) {
        if (i !== profileToSaveIndex) {
          allProfiles.profiles[i] = angular.copy(backupProfileState.profiles[i]);
        }
      }

      _.forEach(allProfiles.profiles, (pro, ind) => {
        pro.triggers[0].data = _.map(pro.triggers[0].data, ([xx, yy]) => [
          (xx * simplifiedEq) - 1,
          ((yy * simplifiedEq) - 1) * -1 || 0
        ]);
        pro.filters = _.map(pro.filters, (newFil) => {
          if (newFil.type === 'sizePercentage') {
            newFil.data = ind === profileToSaveIndex ? detectionPercents : newFil.data;
          } else if (newFil.type !== 'excludeArea') {
            newFil.data = Number(newFil.data);
          }
          return newFil;
        });
      });
      // concat the profiles not relevant to the current stream, as they must all be sent in the request
      allProfiles.profiles = [...allProfiles.profiles, ...irrelevantProfiles];

    } else {
      allProfiles = angular.copy(vm.zoneProfiles);
    }
    return CameraService.syncVmd4Conf(vm.camId, allProfiles)
      .then(() => {
        if (backupProfile) {
          // Must update backup in case reset button is hit after saving
          backupProfile.triggers[0].data = angular.copy(triggers);
          const { filters, name, enabled } = updatedProfile || {};
          backupProfile.filters = filters ? angular.copy(filters) : backupProfile.filters;
          backupProfile.name = name;
          backupProfile.enabled = enabled;
        }

        // Update the alarm path to reflect the new saved polygon
        ZoneSelectionPolyService.resetAlarmPath();

        growlMessage.destroy();
        return growl.success('Profiles successfully saved');
      })
      .catch((err) => {
        growlMessage.destroy();
        return growl.error(err.message, {
          title: 'Profiles could not be saved:'
        });
      });
  }

  // TODO: burn all of vmd1 asap
  function saveVmd1Zone() {
    const zone = vm.activeProfile;
    const cords = ZoneSelectionRectService.getRectCoordinates();

    const degrees = parseInt(vm.rotation, 10);
    const convCords = angular.copy(cords);
    // Flip to normal coordinates
    convCords.y = -convCords.y;
    convCords.y2 = -convCords.y2;
    // Do the opposite translate
    if (degrees === rightAngle || degrees === halfCircle) {
      convCords.x -= cropSize;
      convCords.x2 -= cropSize;
    }
    if (degrees === halfCircle || degrees === threeQuarters) {
      convCords.y += cropSize;
      convCords.y2 += cropSize;

    }

    // Scale the cords to the positive x axis
    convCords.x = (Math.abs(convCords.x) * maxRPGDamage) / cropSize;
    convCords.x2 = (Math.abs(convCords.x2) * maxRPGDamage) / cropSize;
    convCords.y = (Math.abs(convCords.y) * maxRPGDamage) / cropSize;
    convCords.y2 = (Math.abs(convCords.y2) * maxRPGDamage) / cropSize;
    // Assign closest point to top-left, and farthest point to bot-right
    zone.left = Math.min(convCords.x, convCords.x2);
    zone.top = Math.min(convCords.y, convCords.y2);
    zone.right = Math.max(convCords.x, convCords.x2);
    zone.bottom = Math.max(convCords.y, convCords.y2);

    // number-to-string directive converts these to strings
    zone.objectsize = Number(zone.objectsize);
    zone.sensitivity = Number(zone.sensitivity);
    zone.history = Number(zone.history);
    zone.minDuration = Number(zone.minDuration);

    // REMOVE THIS SHIT CODE!!! EMERGENCY FIX TO HIDE OUR JANK FROM CUSTOMERS

    if (zone.bottom > maxRPGDamage) {
      zone.bottom = maxRPGDamage;
    }

    CameraService.saveZone(vm.camId, zone)
      .then(() => {
        zone.cords = cords;
        backupProfileState[vm.prevInd] = zone;
        growlMessage.destroy();
        growlMessage = growl.success('Saved zone!');
      })
      .catch((error) => {
        $log.error('Error: ', error.message || error);
        growlMessage.destroy();
        growlMessage = growl.error(error.message || error, {
          title: 'Error saving zone:'
        });
      });
  }

  function getZones(id) {
    return CameraService.getZones(id)
      .then(success => success.data);
  }

  function getRotation(id) {
    return CameraService.getRotation(id)
      .then(success => success.data.rotation);
  }

  function toggleOverlayAction(show) {
    vm.showOverlays = show;
  }

  function updateLightZoneOverlay($event) {
    $scope.$apply(() => {
      vm.lightZoneOverlay = $event;
    });
  }
}

export default {
  name: 'zone',
  template,
  controller: ZoneController,
  controllerAs: 'ZoneCtrl',
  bindings: {
    resolve: '<',
    dismiss: '&'
  }
};
